import { ethers } from 'ethers';

export const approve = async (tokenContract, targetAddress, account) => {
  return tokenContract.methods
    .approve(targetAddress, ethers.constants.MaxUint256)
    .send({ from: account });
};
